import { createApi } from '@reduxjs/toolkit/query/react';
import apiClient from '../utils/interceptor';

const axiosBaseQuery = async (arg, api) => {
  const { url, method = 'GET', data, params, headers } = arg || {};

  if (!url) {
    return {
      error: {
        status: 'NO_URL',
        data: 'No URL provided to baseQuery'
      }
    };
  }

  // DEBUG: log every RTK Query request
  console.log('[API][request]', { url, method, params, data });

  try {
    const result = await apiClient({
      url,
      method,
      data,
      params,
      headers,
      signal: api?.signal
    });

    // DEBUG: log every RTK Query response
    console.log('[API][response]', {
      url,
      status: result?.status,
      data: result?.data
    });

    return { data: result.data };
  } catch (axiosError) {
    const err = axiosError;

    // Superseded/StrictMode-doubled requests abort via `signal` — not a real error.
    if (err.code === 'ERR_CANCELED' || apiClient.isCancel?.(err)) {
      return { error: { status: 'CANCELED', data: 'Request canceled' } };
    }

    console.error('[API][error]', {
      url,
      status: err.response?.status,
      data: err.response?.data || err.message
    });

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message
      }
    };
  }
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery,
  tagTypes: ['User', 'HomeContent', 'EmployeeWellnessContent', 'ApicContent', 'Memberships', 'ProductTags', 'Products', 'MyApps', 'ActiveCart'],
  keepUnusedDataFor: 10 * 60,
  refetchOnMountOrArgChange: 5 * 60,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  retry: (failureCount, error) => {
    if (error?.status === 401 || error?.status === 403) {
      console.error('Authentication error - not retrying');
      return false;
    }
    return failureCount < 3;
  },
  endpoints: (builder) => ({})
});
